module.exports = __webpack_public_path__ + "img/unavailable-icon.47a1a089.png";